// extracted by mini-css-extract-plugin
export default {"cls1":"iJhXcbrh836R6rkztS2a","cls2":"qqIfe3nNsWlltCKRmK6Q iJhXcbrh836R6rkztS2a"};